export const LANGUAGES: Record<string, string> = {
  FR: 'languages/french.json',
  EN: 'languages/english.json',
  DE: 'languages/english.json',
  JP: 'languages/english.json',
}

export const CATEGORY_TITLE_KEYS: Record<string, string> = {
  FR: 'title_fr',
  EN: 'title_en',
  DE: 'title_de',
  JP: 'title_jp',
}

export const FEATURES: Record<string, string> = {
  IPTC: 'iptc',
  ADMIN: 'admin',
  CART: 'cart',
}

export const APP_VERSION = process.env.VUE_APP_VERSION//'0.1.39'

export const MAX_HOURS_SIGN_IN = 24

export const KEY_SEARCH_TEXT = 'search_text'
export const KEY_SEARCH_TYPE = 'search_type'

export const KEY_USERS = 'users'
export const KEY_STATUS = 'status'

export const KEY_DATE_FROM = 'date_from'
export const KEY_DATE_TO = 'date_to'

export const KEY_ACTIVE = 'active'

export const KEY_ZIP = 'zip'
export const KEY_ITEM = 'item'

export const PHOTO_NUM_ITEMS_PAGE_INIT = 100
export const PHOTO_NUM_ITEMS_ADMIN = 10

export const CART_NUM_ITEMS_PER_PAGE = 50

export const PHOTO_HOME_NUM_ITEMS_PAGE_INIT = 6

export const PHOTO_LIST_LEGEND_NUM_CHARACTERS = 60

export const TEXT_KEYS: Record<string, string> = {
  COMMON_ACTION_SIGN_IN: 'common_action_sign_in',
  COMMON_EMAIL: 'common_label_email',
  COMMON_PASSWORD: 'common_label_password',

  WIP_TITLE: 'page_work_in_progress_title',
  WIP_SUB_TITLE: 'page_work_in_progress_sub_title',
  WIP_SIGN_IN_LABEL: 'page_work_in_progress_label',

  FOOTER_DATE_LABEL: 'footer_date_label',
  FOOTER_LEGAL_LABEL: 'footer_legal_label',

  ADMIN_MODAL_DELETE_TITLE: 'admin_modal_delete_title',
  ADMIN_MODAL_DELETE_BODY: 'admin_modal_delete_body',
  ADMIN_MODAL_DELETE_BUTTON_CANCEL: 'admin_modal_delete_button_cancel',
  ADMIN_MODAL_DELETE_BUTTON_CONFIRM: 'admin_modal_delete_button_confirm',

  ADMIN_MODAL_VALIDATION_TITLE: 'admin_modal_validation_title',
  ADMIN_MODAL_VALIDATION_BODY: 'admin_modal_validation_body',
  ADMIN_MODAL_VALIDATION_BUTTON_CANCEL: 'admin_modal_validation_button_cancel',
  ADMIN_MODAL_VALIDATION_BUTTON_CONFIRM:
    'admin_modal_validation_button_confirm',

  ADMIN_MODAL_VALIDATION_NO_ELIGIBLE_PHOTO: 'admin_modal_validation_no_eligible_photo',

  BUTTON_OK: 'button_ok',

  SIGN_IN_CONNECT: 'sign_in_connect',
  SIGN_IN_BUTTON_OK: 'sign_in_button_ok',
  SIGN_IN_NO_ACCOUNT: 'sign_in_no_account',
  SIGN_IN_PLACEHOLDER_EMAIL: 'sign_in_placeholder_email',
  SIGN_IN_PLACEHOLDER_PASSWORD: 'sign_in_placeholder_password',

  SIGNED_IN_TITLE: 'signed_in_hello',
  SIGNED_IN_DISCONNECT: 'signed_in_disconnect',
  SIGNED_IN_CART_TOOLTIP: 'signed_in_cart_tooltip',

  DATE_SELECTION_TITLE: 'date_selection_title',
  DATE_SELECTION_LABEL_DATE_FROM: 'date_selection_label_date_from',
  DATE_SELECTION_LABEL_DATE_TO: 'date_selection_label_date_to',

  NAV_BAR_WELCOME: 'nav_bar_search_welcome',
  NAV_BAR_VIDEOS: 'nav_bar_videos',
  NAV_BAR_PHOTOS_AGENCY: 'nav_bar_search_photos_agency',
  NAV_BAR_CORPORATE: 'nav_bar_search_corporate',
  NAV_BAR_CONTACT: 'nav_bar_search_contact',

  NAV_BAR_SEARCH_INPUT: 'nav_bar_search_search_input',
  NAV_BAR_SEARCH_SEARCH_LARGE: 'nav_bar_search_search_large',
  NAV_BAR_SEARCH_SEARCH_STRICT: 'nav_bar_search_search_strict',
  NAV_BAR_SEARCH_SEARCH_STRICT_TITLE: 'nav_bar_search_search_strict_title',
  NAV_BAR_SEARCH_SEARCH_TITLE_START_WITH:
    'nav_bar_search_search_title_start_with',
  NAV_BAR_SEARCH_SEARCH_BUTTON: 'nav_bar_search_search_button',

  CATEGORY_TITLE: 'category_title',

  PARTNERS_TITLE: 'partners_title',

  TITLE_BANNER_CART: 'title_banner_cart',
  TITLE_BANNER_CART_HISTORY: 'title_banner_cart_history',
  TITLE_BANNER_PARTNERS: 'title_banner_partners',
  TITLE_BANNER_USERS: 'title_banner_users',
  TITLE_BANNER_VIDEOS: 'title_banner_videos',

  CART_HEADER_PHOTO: 'cart_header_photo',
  CART_HEADER_LEGEND: 'cart_header_legend',
  CART_HEADER_DATE: 'cart_header_date',
  CART_BUTTON_DELETE: 'cart_button_delete',
  CART_EXPLANATION_ZIP: 'cart_explanation_zip',
  CART_INCLUDE_IPTC: 'cart_include_iptc',
  CART_BUTTON_DOWNLOAD: 'cart_button_download',
  CART_BUTTON_REMOVAL_ALL: 'cart_button_remove_all',
  CART_BUTTON_SEE_DETAILS: 'cart_button_see_details',
  CART_BUTTON_PUT_BACK_IN_CART: 'cart_button_put_back_in_cart',
  CART_FOOTER: 'cart_footer',
  CART_PREV_CART_TITLE: 'cart_previous_cart_title',
  CART_PREV_CART_NUM_PHOTOS: 'cart_previous_cart_num_photos',
  CART_PREV_CART_DATE: 'cart_previous_cart_date',

  PHOTO_MODAL_ADD_TO_CART: 'photo_modal_add_to_cart',
  PHOTO_MODAL_REMOVE_FROM_CART: 'photo_modal_remove_from_cart',

  AGENCY_CONTENT_1: 'agency_content_1',
  AGENCY_CONTENT_2: 'agency_content_2',
  AGENCY_CONTENT_3: 'agency_content_3',
  AGENCY_CONTENT_4: 'agency_content_4',
  AGENCY_SIGNATURE_MAIN: 'agency_signature_main',

  CONTACT_TITLE: 'contact_title',
  CONTACT_PLACEHOLDER_EMAIL: 'contact_placeholder_email',
  CONTACT_LABEL_MESSAGE: 'contact_label_message',
  CONTACT_BUTTON_SEND: 'contact_button_send',

  CORPORATE_TITLE: 'corporate_title',
  CORPORATE_SUB_TITLE: 'corporate_sub_title',
  CORPORATE_CONTENT_1: 'corporate_content_1',
  CORPORATE_CONTENT_2: 'corporate_content_2',
  CORPORATE_CONTENT_3: 'corporate_content_3',
  CORPORATE_CONTENT_4: 'corporate_content_4',
  CORPORATE_CONTENT_5: 'corporate_content_5',
  CORPORATE_CONTENT_6: 'corporate_content_6',
  CORPORATE_SIGNATURE_MAIN: 'corporate_signature_main',

  LABEL_TOTAL: 'label_total',

  PHOTO_TITLE_HOME: 'photo_title_home',
  PHOTO_TITLE_CATEGORY: 'photo_title_category',

  PHOTO_ITEM_LIST_HOME_NO_TITLE: 'photo_item_list_home_no_title',

  PHOTO_RESULTS_NO_PHOTO: 'photo_results_no_photo',
  PHOTO_RESULTS_LOADING_PHOTO: 'photo_results_loading_photo',

  PHOTO_IPTC_DETAILS_TITLE: 'photo_iptc_details_title',

  PHOTO_IPTC_DETAILS_LABEL_TITLE: 'photo_iptc_details_label_title',
  PHOTO_IPTC_DETAILS_LABEL_REPORTAGE: 'photo_iptc_details_label_reportage',
  PHOTO_IPTC_DETAILS_LABEL_LEGEND: 'photo_iptc_details_label_legend',
  PHOTO_IPTC_DETAILS_LABEL_TAGS: 'photo_iptc_details_label_tags',
  PHOTO_IPTC_DETAILS_LABEL_AUTHOR: 'photo_iptc_details_label_author',
  PHOTO_IPTC_DETAILS_LABEL_COPYRIGHT: 'photo_iptc_details_label_copyright',
  PHOTO_IPTC_DETAILS_LABEL_DATE_CREATION:
    'photo_iptc_details_label_date_creation',
  PHOTO_IPTC_DETAILS_LABEL_DATE_ADDED: 'photo_iptc_details_label_date_added',
  PHOTO_IPTC_DETAILS_LABEL_DATE_UPDATED:
    'photo_iptc_details_label_date_updated',

  PHOTO_IPTC_DETAIL_LABEL_CANNOT_BE_EMPTY:
    'photo_iptc_details_label_cannot_be_empty',

  PHOTO_IPTC_DETAILS_LABEL_CREDIT: 'photo_iptc_details_label_credit',
  PHOTO_IPTC_DETAILS_LABEL_PROVINCE: 'photo_iptc_details_label_province',
  PHOTO_IPTC_DETAILS_LABEL_CATEGORY: 'photo_iptc_details_label_category',
  PHOTO_IPTC_DETAILS_LABEL_INSTRUCTIONS:
    'photo_iptc_details_label_instructions',
  PHOTO_IPTC_DETAILS_LABEL_DATE_DIGITAL_CREATION:
    'photo_iptc_details_label_date_digital_creation',
  PHOTO_IPTC_DETAILS_LABEL_DATE_VALIDATED:
    'photo_iptc_details_label_date_validated',

  PHOTO_IPTC_DETAILS_LABEL_CITY: 'photo_iptc_details_label_city',
  PHOTO_IPTC_DETAILS_LABEL_COUNTRY: 'photo_iptc_details_label_country',
  PHOTO_IPTC_DETAILS_LABEL_WRITER: 'photo_iptc_details_label_writer',
  PHOTO_IPTC_DETAILS_LABEL_DATA_SOURCE: 'photo_iptc_details_label_date_source',
  PHOTO_IPTC_DETAILS_LABEL_ORIGINAL_REFERENCE:
    'photo_iptc_details_label_date_original_reference',
  PHOTO_IPTC_DETAILS_LABEL_OBJECT_NAME:
    'photo_iptc_details_label_date_object_name',

  WEBSITE_URL: 'website_url',

  PHOTO_MODAL_TITLE: 'photo_modal_title',
  VIDEO_MODAL_TITLE: 'video_modal_title',

  PHOTO_MULTIPLE_EDIT_MODAL_TITLE: 'photo_multiple_edit_modal_title',

  PHOTO_MODAL_BUTTON_VALIDATE: 'photo_modal_button_validate',
  PHOTO_MODAL_BUTTON_DELETE: 'photo_modal_button_delete',
  PHOTO_MODAL_BUTTON_BLOCK: 'photo_modal_button_photo_block',

  ADMIN_MENU_TITLE: 'admin_menu_title',
  ADMIN_MENU_CARTS: 'admin_menu_carts',
  ADMIN_MENU_USERS: 'admin_menu_users',
  ADMIN_MENU_PHOTO_VALIDATION: 'admin_menu_photo_validation',
  ADMIN_MENU_UPLOAD_HISTORY: 'admin_menu_upload_history',

  TITLE_LOGINS_HISTORY: 'title_logins_history',
  TITLE_FTP_RECEIVED_HISTORY: 'title_ftp_received_history',
  TITLE_PHOTO_VALIDATION: 'title_photo_validation',
  TITLE_PHOTO_SEARCHS_HISTORY: 'title_photo_searchs_history',

  MENU_HISTORY: "menu_history",
  MENU_HISTORY_CART: "menu_history_cart",
  MENU_HISTORY_FTP_RECEIVED: "menu_history_ftp_received",
  MENU_HISTORY_LOGIN: "menu_history_login",
  MENU_HISTORY_PHOTO_SEARCH: "menu_history_photo_search",

  ALERT_NO_ELEMENTS: "alert_no_elements",

  VIDEOS_INTRODUCTION_TEXTS_ENGAGING_SENTENCE:
    'videos_introduction_texts_engaging_sentence',
  VIDEOS_INTRODUCTION_TEXTS: 'videos_introduction_texts',
  VIDEOS_INTRODUCTION_TEXTS_BULLET_POINTS:
    'videos_introduction_texts_bullet_points',

  CART_ADMIN_LIST_PHOTO_HEADER_PHOTO: 'cart_admin_list_photo_header_photo',
  CART_ADMIN_LIST_PHOTO_HEADER_TITLE: 'cart_admin_list_photo_header_title',
  CART_ADMIN_LIST_PHOTO_HEADER_LEGEND: 'cart_admin_list_photo_header_legend',

  CART_ADMIN_FILTER_USERS: 'cart_admin_filter_users',
  CART_ADMIN_FILTER_NO_USERS: 'cart_admin_filter_no_users',

  CART_ADMIN_TYPE_AGGREGATE: 'cart_addmin_filter_type_mode_aggregate',

  CART_ADMIN_DATE_SELECTION_TITLE: 'cart_admin_date_selection_title',
  CART_ADMIN_HEADER_TIMESTAMP: 'cart_admin_users_table_header_timestamp',
  CART_ADMIN_HEADER_USER: 'cart_admin_users_table_header_user',
  CART_ADMIN_HEADER_NUM_PHOTOS: 'cart_admin_users_table_header_num_photos',
  CART_ADMIN_HEADER_STATUS: 'cart_admin_users_table_header_status',
  CART_ADMIN_NO_PURCHASES: 'cart_admin_no_purchases',

  CART_ADMIN_PHOTO_HEADER_PHOTO: 'cart_admin_photo_header_photo',
  CART_ADMIN_PHOTO_HEADER_TITLE: 'cart_admin_photo_header_title',
  CART_ADMIN_PHOTO_HEADER_TIMESTAMP: 'cart_admin_photo_header_timestamp',

  LABEL_LOADING: 'label_loading',

  USER_ADMIN_FILTER_COMPANIES: 'user_admin_filter_companies',
  USER_ADMIN_FILTER_NO_COMPANIES: 'user_admin_filter_no_companies',

  USER_ADMIN_HEADER_TIMESTAMP: 'user_admin_users_table_header_timestamp',
  USER_ADMIN_HEADER_USER: 'user_admin_users_table_header_user',
  USER_ADMIN_HEADER_COMPANY: 'user_admin_users_table_header_company',
  USER_ADMIN_HEADER_TYPE: 'user_admin_users_table_header_type',
  USER_ADMIN_HEADER_STATUS: 'user_admin_users_table_header_status',
  USER_ADMIN_NO_USERS: 'user_admin_no_users',

  USER_ADMIN_FILTER_NAME_COMPANY: 'user_admin_filter_name_company',
  USER_ADMIN_FILTER_NAME_USER: 'user_admin_filter_name_user',

  USER_ADMIN_STATUS_ACTIVE: 'user_admin_status_active',
  USER_ADMIN_STATUS_INACTIVE: 'user_admin_status_inactive',

  PHOTO_ADMIN_SETTING_HOME_LABEL_PAGE: 'photo_admin_setting_home_label_page',
  PHOTO_ADMIN_SETTING_HOME_LABEL_POSITION:
    'photo_admin_setting_home_label_position',

  PHOTO_ADMIN_TOOLTIP_BUTTON_VALIDATE: 'photo_admin_tooltip_button_validate',
  PHOTO_ADMIN_TOOLTIP_BUTTON_EDIT: 'photo_admin_tooltip_button_edit',
  PHOTO_ADMIN_TOOLTIP_BUTTON_DOWNLOAD: 'photo_admin_tooltip_button_download',
  PHOTO_ADMIN_TOOLTIP_BUTTON_DELETE: 'photo_admin_tooltip_button_delete',

  USER_ADMIN_MODAL_TITLE_NEW_USER: 'user_admin_modal_title_new_user',
  USER_ADMIN_MODAL_TITLE_UPDATE_USER: 'user_admin_modal_title_update_user',

  USER_ADMIN_LOADING_LIST_USERS: 'user_admin_loading_list_users',

  USER_ADMIN_TOOLTIP_UPDATE_PROFILE: 'user_admin_tooltip_update_profile',
  USER_ADMIN_TOOLTIP_DELETE_PROFILE: 'user_admin_tooltip_delete_profile',

  USER_ADMIN_MODAL_LABEL_NAME: 'user_admin_modal_label_name',
  USER_ADMIN_MODAL_LABEL_EMAIL: 'user_admin_modal_label_email',
  USER_ADMIN_MODAL_LABEL_USERNAME: 'user_admin_modal_label_username',
  USER_ADMIN_MODAL_LABEL_PASSWORD: 'user_admin_modal_label_password',
  USER_ADMIN_MODAL_LABEL_GROUPS: 'user_admin_modal_label_groups',
  USER_ADMIN_MODAL_LABEL_STATUS: 'user_admin_modal_label_status',
  USER_ADMIN_MODAL_LABEL_FTP_USER: 'user_admin_modal_label_ftp_user',
  USER_ADMIN_MODAL_LABEL_COMPANY: 'user_admin_modal_label_company',
  USER_ADMIN_MODAL_LABEL_USER_TYPE: 'user_admin_modal_label_user_type',

  USER_ADMIN_MODAL_BUTTON_CREATE: 'user_admin_modal_button_create',
  USER_ADMIN_MODAL_BUTTON_UPDATE: 'user_admin_modal_button_update',

  USER_ADMIN_MODAL_USERNAME_ALREADY_EXIST:
    'user_admin_modal_username_already_exist',
  USER_ADMIN_MODAL_PASSWORD_HINT: 'user_admin_modal_password_hint',

  USER_ADMIN_BUTTON_NEW_USER: 'user_admin_button_new_user',
  USER_ADMIN_BUTTON_REFRESH_LIST: 'user_admin_button_refresh_list',
  USER_ADMIN_INPUT_PLACEHOLDER_FTP_USER:
    'user_admin_input_placeholder_ftp_user',

  USER_ADMIN_CHECKBOX_SEND_CONNECTION:
    'user_admin_checkbox_send_connection_information',

  LEGAL_MENTION_OPENING_1: 'legal_mention_opening_1',
  LEGAL_MENTION_OPENING_2: 'legal_mention_opening_2',
  LEGAL_MENTION_RESPONSIBILITY_LIMITATION_TITLE:
    'legal_mention_responsibility_limitation_title',
  LEGAL_MENTION_RESPONSIBILITY_LIMITATION_TEXT_1:
    'legal_mention_responsibility_limitation_text_1',
  LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_SUBTITLE:
    'legal_mention_responsibility_limitation_intellectual_property_subtitle',
  LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_TEXT_1:
    'legal_mention_responsibility_limitation_intellectual_property_text_1',
  LEGAL_MENTION_RESPONSIBILITY_LIMITATION_INTELECTUAL_PROPERTTY_TEXT_2:
    'legal_mention_responsibility_limitation_intellectual_property_text_2',

  LEGAL_MENTION_PERSONAL_DATA_TITLE: 'legal_mention_personal_data_title',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_1: 'legal_mention_personal_data_text_1',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_2: 'legal_mention_personal_data_text_2',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_3: 'legal_mention_personal_data_text_3',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_4: 'legal_mention_personal_data_text_4',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_5: 'legal_mention_personal_data_text_5',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_6: 'legal_mention_personal_data_text_6',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_7: 'legal_mention_personal_data_text_7',
  LEGAL_MENTION_PERSONAL_DATA_TEXT_8: 'legal_mention_personal_data_text_8',

  LEGAL_MENTION_GENERAL_DISPOSITION_TITLE:
    'legal_mention_general_disposition_title',
  LEGAL_MENTION_GENERAL_DISPOSITION_TEXT:
    'legal_mention_general_disposition_text',

  LEGAL_MENTION_CHALLENGE_TITLE: 'legal_mention_challenge_title',
  LEGAL_MENTION_CHALLENGE_TEXT_1: 'legal_mention_challenge_text_1',
  LEGAL_MENTION_CHALLENGE_TEXT_2: 'legal_mention_challenge_text_2',

  PHOTO_ADMIN_SETTINGS_IS_HOME_CHECKBOX:
    'photo_admin_settings_is_home_checkbox',
  PHOTO_ADMIN_SETTINGS_HOME_SELECT_PAGE: 'photo_admin_setting_home_select_page',

  PHOTO_ADMIN_FILTER_STATUS_TITLE: 'photo_admin_filter_status_title',

  PHOTO_ADMIN_FILTER_ORDER_TITLE: 'photo_admin_filter_order_title',

  PHOTO_ADMIN_NO_PHOTOS: 'photo_admin_no_photos',

  PHOTO_VALIDATION_CHECKBOX_IS_HISTORY: 'photo_validation_checkbox_is_history',

  PHOTO_ADMIN_MULTIPLE_EDITION_LABEL: 'photo_admin_multiple_edition_label',

  PHOTO_ADMIN_MULTIPLE_LABEL_SELECT_ALL:
    'photo_admin_multiple_label_select_all',
  PHOTO_ADMIN_MULTIPLE_LABEL_UNSELECT_ALL:
    'photo_admin_multiple_label_unselect_all',

  PHOTO_ADMIN_MULTIPLE_MODAL_VALIDATION_TITLE:
    'photo_admin_multiple_modal_validation_title',
  PHOTO_ADMIN_MULTIPLE_MODAL_DELETE_TITLE:
    'photo_admin_multiple_modal_delete_title',
  PHOTO_ADMIN_MULTIPLE_MODAL_EDITION_TITLE:
    'photo_admin_multiple_modal_edition_title',

  PHOTO_ADMIN_MULTIPLE_MODAL_CONTENT: 'photo_admin_multiple_modal_content',

  PHOTO_VALIDATION_MODAL_INVALID_PHOTOS_TITLE:
    'photo_validation_modal_invalid_photos_title',
  PHOTO_VALIDATION_MODAL_INVALID_PHOTOS_FOR_VALIDATION:
    'photo_validation_modal_invalid_photos_for_validation',

  PHOTO_ADMIN_LOADING_LIST_PHOTOS: 'photo_admin_loading_list_photos',

  PHOTO_ADMIN_TABLE_HEADER_PHOTO: 'photo_admin_table_header_photo',
  PHOTO_ADMIN_TABLE_HEADER_TITLE: 'photo_admin_table_header_title',
  PHOTO_ADMIN_TABLE_HEADER_TIMESTAMP: 'photo_admin_table_header_timestamp',
  PHOTO_VALIDATION_TABLE_HEADER_TIMESTAMP_VALIDATED:
    'photo_validation_table_header_timestamp_validated',
  PHOTO_ADMIN_TABLE_HEADER_COPYRIGHT: 'photo_admin_table_header_copyright',
  PHOTO_ADMIN_TABLE_HEADER_AUTHOR: 'photo_admin_table_header_author',
  PHOTO_ADMIN_TABLE_HEADER_IS_DOUBLON: 'photo_admin_table_header_is_doublon',
  PHOTO_ADMIN_TABLE_HEADER_ERROR: 'photo_admin_table_header_error',

  HEADER_USERNAME: 'header_username',
  HEADER_HAS_RESULTS: 'header_has_results',
  HEADER_TIMESTAMP: 'header_timestamp',

  HEADER_TIMESTAMP_SEARCH_TEXT: 'header_timestamp_search_text',
  HEADER_SEARCH_TEXT: 'header_search_text',

  PHOTO_ADMIN_TABLE_HEADER_COMPANY: 'photo_admin_table_header_company',
  PHOTO_ADMIN_TABLE_HEADER_STATUS: 'photo_admin_table_header_status',

  PHOTO_IPTC_MAIN_TITLE: 'photo_iptc_main_title',
  PHOTO_IPTC_SECONDARY_TITLE: 'photo_iptc_secondary_title',

  PHOTO_VALIDATION_ERROR_PHOTO_DOUBLON: 'photo_validation_error_photo_doublon',
  PHOTO_VALIDATION_ERROR_PHOTO_TOO_BIG: 'photo_validation_error_photo_too_big',

  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_PHOTO:
    'photos_upload_history_table_header_photo',
  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_TITLE:
    'photos_upload_history_table_header_title',
  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_TIMESTAMP_UPLOAD:
    'photos_upload_history_table_header_timestamp_upload',
  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_USERNAME:
    'photos_upload_history_table_header_username',
  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_PHOTOS_COUNT:
    'photos_upload_history_table_header_photos_count',
  PHOTO_UPLOAD_HISTORY_TABLE_HEADER_IS_REMOVED:
    'photos_upload_history_table_header_is_removed',
  PHOTO_UPLOAD_HISTORY_NO_ITEMS: 
    'photos_upload_history_no_items',

  PHOTO_UPLOAD_HISTORY_LABEL_UPLOAD_DATE:
    'photos_upload_history_label_upload_date',

  HEADER_TITLE: 'header_title',
  HEADER_TIMESTAMP_UPLOAD: 'header_timestamp_upload',
  HEADER_TIMESTAMP_SIGNED_IN: 'header_timestamp_signed_in',
  HEADER_PHOTO: 'header_photo',

  LABEL_TIMESTAMP_SEARCH_TEXT_PERIOD: "label_timestamp_search_text_period",
  LABEL_TIMESTAMP_SIGNED_IN_PERIOD: "label_timestamp_signed_in_period",

  TOAST_SIGNED_IN_SUCCESS: 'toast_signed_in_success',
  TOAST_SIGNED_IN_FAILURE: 'toast_signed_in_failure',

  TOAST_CONTACT_SEND_MESSAGE_SUCCESS: 'toast_contact_send_message_success',
  TOAST_CONTACT_SEND_MESSAGE_FAILURE: 'toast_contact_send_message_failure',

  TOAST_NEW_USER_SUCCESS: 'toast_new_user_success',
  TOAST_NEW_USER_FAILURE: 'toast_new_user_failure',

  TOAST_UPDATE_USER_SUCCESS: 'toast_update_user_success',
  TOAST_UPDATE_USER_FAILURE: 'toast_update_user_failure',

  TOAST_DELETE_USER_SUCCESS: 'toast_delete_user_success',
  TOAST_DELETE_USER_FAILURE: 'toast_delete_user_failure',

  TOAST_DELETE_PHOTO_SUCCESS: 'toast_delete_photo_success',
  TOAST_DELETE_PHOTO_FAILURE: 'toast_delete_photo_failure',

  TOAST_UPDATE_PHOTO_SUCCESS: 'toast_update_photo_success',
  TOAST_UPDATE_PHOTO_FAILURE: 'toast_update_photo_failure',

  TOAST_VALIDATE_MULTIPLE_PHOTO_SUCCESS:
    'toast_validate_multiple_photo_success',
  TOAST_VALIDATE_MULTIPLE_PHOTO_FAILURE:
    'toast_validate_multiple_photo_failure',

  TOAST_DELETE_MULTIPLE_PHOTO_SUCCESS: 'toast_delete_multiple_photo_success',
  TOAST_DELETE_MULTIPLE_PHOTO_FAILURE: 'toast_delete_multiple_photo_failure',

  TOAST_UPDATE_MULTIPLE_PHOTO_SUCCESS: 'toast_update_multiple_photo_success',
  TOAST_UPDATE_MULTIPLE_PHOTO_FAILURE: 'toast_update_multiple_photo_failure',

  TOAST_DOWNLOAD_MULTIPLE_PHOTO_SUCCESS:
    'toast_download_multiple_photo_success',
  TOAST_DOWNLOAD_MULTIPLE_PHOTO_FAILURE:
    'toast_download_multiple_photo_failure',
}

export enum SIGNED_IN_STATUS {
  IDLE = 0,
  SIGNED_IN,
  RUNNING,
  FAILED,
}

export enum STATUS_CREATE {
  IDLE = 0,
  CREATING,
  FAILED,
}

export enum API_CALL_STATUS {
  IDLE = 0,
  RUNNING,
  FAILED,
}

export enum SEARCH_TYPE {
  LARGE = 0,
  STRICT,
  TITLE,
  STRICT_TITLE,
  TITLE_START_WITH,
}

export enum LANGUAGE_LOADED_STATUS {
  NO = 0,
  LOADING,
  LOADED,
  FAILED,
}

export enum STATUS_LOAD {
  IDLE = 0,
  LOADING,
  LOADED,
  FAILED,
}

export enum STATUS {
  IDLE = 0,
  RUNNING,
  SUCCESS,
  FAILED,
}

export enum STATUS_DELETE_API {
  IDLE = 0,
  DELETING,
  FAILED,
  SUCCESS,
}

export enum STATUS_UPDATE_API {
  IDLE = 0,
  UPDATING,
  FAILED,
  SUCCESS,
}

export enum STATUS_API_CALL {
  IDLE = 0,
  RUNNING,
  FAILED,
  SUCCESS,
}

export enum MULTIPLE_TYPE {
  NONE,
  DELETE,
  VALIDE,
  UPDATE,
  DOWNLOAD,
}

export interface PhotoValidationPayload {
  offset: number
  limit: number
  order: number
  status: number
  timestamp_from: string
  timestamp_to: string
}

export const PHOTO_STATUS: Array<Record<string, string>> = [
  {
    BACKEND_VALUE: 'ACTIVE',
    TEXT_KEY: 'photo_admin_status_active',
  },
  /* {
    BACKEND_VALUE: "INACTIVE",
    TEXT_KEY: 'photo_admin_status_inactive'
  },*/ {
    BACKEND_VALUE: 'PENDING_VALIDATION',
    TEXT_KEY: 'photo_admin_status_pending_validation',
  },
]

export const TIMESTAMP_FORMAT = 'yyyy-MM-dd HH:mm:ss'

interface PhotoValidationOrder {
  VALUE: number
  TEXT_KEY: string
}

export const PHOTO_FILTER_ORDERS: Array<PhotoValidationOrder> = [
  {
    VALUE: 0,
    TEXT_KEY: 'photo_admin_filter_most_recent',
  },
  {
    VALUE: 1,
    TEXT_KEY: 'photo_admin_filter_least_recent',
  },
]

export const PURCHASE_STATUS: Array<Record<string, string>> = [
  {
    BACKEND_VALUE: 'PENDING',
    TEXT_KEY: 'cart_admin_status_pending',
  },
  {
    BACKEND_VALUE: 'VALIDATED',
    TEXT_KEY: 'cart_admin_status_validated',
  },
]

export const CART_SINGLE_PURCHASE_FILTERS: Array<Record<string, string | number>> = [
  {
    VALUE: 0,
    TEXT_KEY: 'cart_addmin_filter_most_recent_purchase',
  },
  {
    VALUE: 1,
    TEXT_KEY: 'cart_addmin_filter_least_recent_purchase',
  },
  {
    VALUE: 2,
    TEXT_KEY: 'cart_addmin_filter_num_photos_most',
  },
  {
    VALUE: 3,
    TEXT_KEY: 'cart_addmin_filter_num_photos_least',
  },
]

export const CART_AGGREGATE_FILTERS: Array<Record<string, string | number>> = [
  {
    VALUE: 2,
    TEXT_KEY: 'cart_addmin_filter_num_photos_most',
  },
  {
    VALUE: 3,
    TEXT_KEY: 'cart_addmin_filter_num_photos_least',
  },
]

export const enum PURCHASE_TYPE {
  SINGLE = 'per_purchase',
  AGGREGATE = 'aggregate'
}

export const CART_ADMIN_FILTER_PER_PURCHASE_DEFAULT = 0
export const CART_ADMIN_FILTER_AGGREGATE_DEFAULT = 2

export const CART_ADMIN_TYPE: Array<Record<string, string>> = [
  {
    VALUE: 'per_purchase',
    TEXT_KEY: 'cart_addmin_filter_type_mode_user',
  },
  {
    VALUE: 'aggregate',
    TEXT_KEY: 'cart_addmin_filter_type_mode_aggregate',
  },
]

export const USER_GROUP_TYPE_ADMINISTRATOR = 'Administrator'
export const USER_GROUP_TYPE_GESTIONNAIRE = 'Gestionnaire'
export const USER_GROUP_TYPE_PROVIDER = 'Provider'
export const USER_GROUP_TYPE_CUSTOMER = 'Customer'

export const USER_GROUP_TYPE: Array<Record<string, string>> = [
  {
    BACKEND_VALUE: USER_GROUP_TYPE_ADMINISTRATOR,
    TEXT_KEY: 'user_admin_status_administrator',
  },
  {
    BACKEND_VALUE: USER_GROUP_TYPE_GESTIONNAIRE,
    TEXT_KEY: 'user_admin_status_gestionnaire',
  },
  {
    BACKEND_VALUE: USER_GROUP_TYPE_PROVIDER,
    TEXT_KEY: 'user_admin_status_provider',
  },
  {
    BACKEND_VALUE: USER_GROUP_TYPE_CUSTOMER,
    TEXT_KEY: 'user_admin_status_consumer',
  },
]

export const USER_STATUS_ACTIVE: Array<Record<string, boolean | string>> = [
  {
    BACKEND_VALUE: true,
    TEXT_KEY: 'user_admin_status_active',
  },
  {
    BACKEND_VALUE: false,
    TEXT_KEY: 'user_admin_status_inactive',
  },
]

export const PHOTO_LIST_CELL_COLOR_DETAILS: Array<Record<string, string>> = [
  {
    COLOR_CLASS: 'bg-warning',
    TEXT_KEY: 'photo_admin_cell_doublon',
  },
  {
    COLOR_CLASS: 'bg-info',
    TEXT_KEY: 'photo_admin_cell_waiting_validation',
  },
]

export const USER_FILTERS_TYPE: Record<string, string> = {
  GROUP: 'group',
  STATUS_ACTIVE: 'status_active',
  COMPANY: 'company',
  NAME: 'name',
}

export const REGEX_EMAIL = /\S+@\S+\.\S+/

export const ROUTER_PATH_HOME = '/'

export const ROUTE_NEED_LOG_IN: Array<string> = [
  '/cart',
  '/cartHistory',
  '/users',
  '/photoValidation',
]

export const KEY_TIMESTAMP_FROM = 'timestamp_from'
export const KEY_TIMESTAMP_TO = 'timestamp_to'

export const HOME_SETTINGS_PAGES: Array<Record<string, string | number>> = [
  {
    VALUE: 0,
    TEXT: '1',
  },
  {
    VALUE: 1,
    TEXT: '2',
  },
  {
    VALUE: 2,
    TEXT: '3',
  },
]

export interface FieldValues {
  backend_key: string
  active: boolean
  value: string
}

export interface MultipleField {
  text_key: string
  backend_key: string
  rows: number
  value: string
}

export const FORM_MULTIPLE_PRIMARY_FIELDS: Array<MultipleField> = [
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_TITLE,
    backend_key: 'title',
    rows: 4,
    value: 'Chris test sport title' + new Date().getTime(),
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_LEGEND,
    backend_key: 'legend',
    rows: 3,
    value: 'Chris test sport legend' + new Date().getTime(),
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_TAGS,
    backend_key: 'tag',
    rows: 1,
    value: 'Chris test sport tag' + new Date().getTime(),
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_OBJECT_NAME,
    backend_key: 'object_name',
    rows: 1,
    value: 'Chris test sport object_name' + new Date().getTime(),
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_AUTHOR,
    backend_key: 'author',
    rows: 1,
    value: 'Chris test sport author' + new Date().getTime(),
  },
]

export const FORM_MULTIPLE_SECOND_FIELDS: Array<MultipleField> = [
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_CREDIT,
    backend_key: 'credit',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_COPYRIGHT,
    backend_key: 'copyright',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_CITY,
    backend_key: 'city',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_PROVINCE,
    backend_key: 'province',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_COUNTRY,
    backend_key: 'country',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_CATEGORY,
    backend_key: 'category',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_WRITER,
    backend_key: 'writer',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_DATA_SOURCE,
    backend_key: 'source',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_INSTRUCTIONS,
    backend_key: 'instructions',
    rows: 1,
    value: '',
  },
  {
    text_key: TEXT_KEYS.PHOTO_IPTC_DETAILS_LABEL_ORIGINAL_REFERENCE,
    backend_key: 'original_reference',
    rows: 1,
    value: '',
  },
]
